import React from "react";
import { Route, Routes } from "react-router-dom";
import { FlightDroneProvider } from "./provider/flight-drone-provider";
import { DronesPage } from "./pages/drones-page";

// No local DroneProvider: the app-level DroneProvider (root providers) already fetches all drones
// and refetches on UPDATE_DRONES. The page narrows to visible statuses client-side via
// partitionDronesPageDrones, so a status-filtered request here would just duplicate that fetch
// (separate RTK cache key + duplicate WS-driven refetch).
const DroneFeature: React.FC = () => {
  return (
    <FlightDroneProvider>
      <Routes>
        <Route index element={<DronesPage />}/>
      </Routes>
    </FlightDroneProvider>
  );
};

export default DroneFeature;
